import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const GridViewContainer = styled.div`
  &.grid-view_skeleton {
    display: grid;
    gap: ${toRem(24)};

    /* Mobile - 1 column */
    grid-template-columns: repeat(1, 1fr);

    /* Tablet - 2 columns */
    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: repeat(2, 1fr);
    }

    /* Desktop - 3 columns */
    @media ${baseVariables.mediaQuery.lg} {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .properties-card_skeleton {
    width: ${toRem(364)};
    height: ${toRem(436)};
    border-radius: ${toRem(16)};
  }
`;
